import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Skeleton } from "@circleco/compass/components/Skeleton";

interface AudioPlayerSkeletonProps {
  className?: string;
}

/**
 * `sm` approximates the media-chrome `md:576` breakpoint, which measures the
 * player element rather than the viewport.
 */
export const AudioPlayerSkeleton = ({
  className,
}: AudioPlayerSkeletonProps) => (
  <div
    className={classNames(
      "border-primary bg-secondary relative flex w-full flex-col justify-center gap-4 overflow-hidden rounded-xl border p-4 sm:min-h-[120px]",
      className,
    )}
    aria-hidden="true"
  >
    <div className="flex items-center gap-4 sm:gap-0">
      <div className="flex size-16 shrink-0 items-center justify-center sm:w-24 sm:pr-4">
        <Skeleton shape="rounded" className="size-16 shrink-0" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col justify-center overflow-hidden">
        <div className="flex min-h-6 items-center">
          <Skeleton shape="pill" className="h-5 w-1/2 max-w-64" />
        </div>

        <div className="ml-[-6px] flex h-8 min-w-0 items-center sm:ml-[-7px]">
          {Array.from({ length: 5 }, (_, index) => (
            <div
              key={index}
              className="flex size-[30px] shrink-0 items-center justify-center sm:size-8"
            >
              <Skeleton shape="rounded" className="size-5" />
            </div>
          ))}
          <Skeleton shape="pill" className="ml-auto hidden h-4 w-16 sm:block" />
        </div>
      </div>
    </div>

    <div className="flex h-5 items-center gap-4 sm:hidden">
      <Skeleton shape="pill" className="h-3 w-8 shrink-0" />
      <Skeleton shape="rounded" className="h-1.5 flex-1" />
      <Skeleton shape="pill" className="h-3 w-8 shrink-0" />
    </div>

    <Skeleton
      shape="rounded"
      className="absolute inset-x-4 bottom-0 hidden h-1.5 sm:block"
    />
  </div>
);
